import { GET_ALL_REVIEWS } from '../Type';

export const getAllReviews = () => {
  return {
    type: GET_ALL_REVIEWS,
    data: {}
  }
}